{
  "form": {
    "required": "{name} je vyžadováno",
    "incomplete": "Ospravedlňujeme sa, ale nie všetky polia sú vyplnené správne.",
    "invalidPhoneNumber": "Neplatné telefónne číslo",
    "phonePlaceholder": "Vyhľadanie predvoľby",
    "oneRequired": "Iba jedno z polí je povinné"
  },
  "orderFlow": {
    "error": {
      "description": "Niečo sa stalo. Vaša objednávka bola neúplná. Skúste to prosím znova."
    },
    "confirmPayment": {
      "description": "O chvíľu budete presmerovaní na platobnú bránu.",
      "redirectToGateway": "Presmerovanie na platobnú bránu"
    },
    "complete": {
      "description": "Vaša objednávka bola úspešne dokončená.",
      "receiptIsReadyToDownload": "Váš doklad je pripravený a môžete si ho stiahnuť do svojho zariadenia."
    },
    "showPaymentFailure": {
      "description": "Vaša platba nebola úspešne dokončená."
    },
    "waitForPayment": {
      "description": "Čakáme na výsledok vašej platby."
    },
    "waitForReceipt": {
      "description": "Vygenerujeme potvrdenie o prijatí. Počkajte chvíľu."
    },
    "timeout": {
      "description": "Časový limit bol prekročený. Pošleme vám oznámenie o výsledku."
    }
  },
  "cancel": "Zrušiť",
  "no": "Nie",
  "yes": "Áno",
  "order": "Objednávka",
  "emailAddress": "E-mailová adresa",
  "phoneNumber": "Telefónne číslo",
  "somethingHappenedTryItAgain": "Niečo sa stalo. Skúste to prosím znova.",
  "previousTab": "Predchádzajúci",
  "nextTab": "Ďalej",
  "goBack": "Vráťte sa späť",
  "download": "Stiahnite si",
  "noMatches": "Žiadna zhoda",
  "firstName": "Krstné meno",
  "lastName": "Priezvisko",
  "companyName": "Názov spoločnosti",
  "regNum": "IČO",
  "vat": "DIČ",
  "regLocation": "Mesto nadácie",
  "taxId": "TAX ID",
  "jobPosition": "Pracovná pozícia",
  "attentionTo": "Venujte pozornosť",
  "street": "Ulica",
  "houseNum": "Číslo domu",
  "city": "Mesto",
  "zip": "ZIP",
  "country": "Krajina",
  "accept": "Prijať",
  "refuse": "Odmietnuť",
  "localeSettings": {
    "title": "Nastavenia jazyka",
    "localeSelect": "Jazyk"
  },
  "baasSimManagementLite": {
    "simAuthenticationFailed": "Overenie pravosti karty SIM zlyhalo",
    "simLoading": "Načítanie karty SIM...",
    "noActivePackage": "Žiadny balík",
    "availablePackages": "Dostupné balíky",
    "simLoadDataFailed": "Načítanie údajov SIM karty sa nepodarilo",
    "inactiveAndSynchronizationInProgress": "Karta SIM nie je aktívna. Synchronizácia stavu môže trvať až 2 hodiny.",
    "login": {
      "authorizationCode": "Authorization Code",
      "authorizationCodeValidation": "Authorization code is max 6 length alphanum code."
    },
    "loginType": {
      "go": "Go",
      "identificationCode": "Identifikačný kód",
      "insertSimIdentification": "Vložte identifikáciu SIM karty",
      "invalidIdentificationCode": "Neplatný identifikačný kód"
    },
    "package": {
      "purchaseInProgress": "Priebežný nákup",
      "buyFor": "Kúpiť za",
      "inactiveAndSynchronizationInProgress": "Karta SIM nie je aktívna. Synchronizácia stavu môže trvať až 2 hodiny."
    },
    "packageOrder": {
      "description": "Pred presmerovaním na platobnú bránu zadajte svoju e-mailovú adresu, na ktorú vám zašleme doklad o zaplatení.",
      "requiredTermsAndConditions": "Pred objednaním balíka musíte súhlasiť s podmienkami",
      "showBillingInfo": "Vyplňte fakturačné údaje",
      "billingName": "Meno"
    },
    "unprocessedPackages": {
      "foundUnprocessed": "Objednávka sa spracováva. Táto operácia môže trvať niekoľko minút. Počkajte, prosím.",
      "warnUnprocesse": "Objednávka sa spracováva. Určite si chcete objednať ďalší balíček?"
    },
    "usageBar": {
      "total": "Celkom",
      "used": "Spotrebované",
      "remaining": "Zostáva",
      "validTo": "Platnosť do"
    }
  },
  "proposal": {
    "acceptForm": {
      "availableOffers": "Dostupné ponuky",
      "companyInformations": "Informácie o spoločnosti",
      "address": "Adresa",
      "contactPersonInformation": "Informácie o kontaktnej osobe",
      "proposalAccpetFailed": "Prijatie ponuky nebolo úspešné",
      "alternative": "Alternatíva",
      "comment": "Komentár",
      "availableOffersHint": "Vyberte jednu alebo viac ponúk, ktoré chcete prijať.",
      "tabs": {
        "offerAndCompany": "Ponuka a spoločnosť",
        "addresses": "Adresy",
        "bankDetail": "Bankové spojenie"
      },
      "personalCustomerPassword": {
        "label": "Osobné heslo zákazníka",
        "hint": "Potrebné na overenie vašej totožnosti, keď kontaktujete náš tím podpory."
      },
      "invoiceReceipt": {
        "title": "Potvrdenie o prijatí faktúry",
        "emailAddress": "E-mailová adresa na prijímanie faktúr",
        "monthlyEmailNotificationNotIncludePDF": "Mesačné e-mailové oznámenie by nemalo obsahovať kópiu elektronickej faktúry vo formáte PDF."
      },
      "billingAddress": {
        "title": "Fakturačná adresa",
        "sameAsCustomerInformation": "Rovnaká adresa ako adresa zákazníka"
      },
      "deliveryAddress": {
        "title": "Dodacia adresa",
        "sameAsCustomerInformation": "Rovnaká adresa ako adresa zákazníka"
      },
      "adminAccessCredentials": {
        "title": "Správca SIM karty / Prístupové údaje pre portál myFUSION",
        "hint": "Správca SIM karty má plné prístupové práva v rámci portálu myFUSION. Správca SIM môže vytvárať ďalších používateľov s rôznymi úrovňami oprávnení.",
        "firstName": "Meno administrátora SIM",
        "lastName": "Priezvisko administrátora SIM",
        "jobPosition": "Pracovné miesta administrátora SIM",
        "phoneNumber": "Telefónne číslo správcu SIM karty",
        "emailAddress": "E-mail administrátora SIM"
      },
      "bankDetails": {
        "title": "Bankové údaje",
        "accountHolder": "Držiteľ účtu",
        "bankName": "Názov banky",
        "bic": "BIC",
        "iban": "IBAN",
        "street": "Ulica (držiteľ účtu)",
        "postalCode": "PSČ (majiteľa účtu)",
        "city": "Mesto (majiteľ účtu)"
      },
      "companyVerification": {
        "title": "Overenie spoločnosti",
        "hint": "Prosím uveďte aspoň jedno z nasledujúcich: Unternehmensregister EUID alebo živnostenský list.",
        "euid": "Unternehmensregister EUID",
        "euidHelp": "European Unique Identifier (napr. DEXXX...)",
        "tradeLicense": "Živnostenský list (PDF)",
        "tradeLicenseHelp": "Nahrajte svoj živnostenský list ako PDF súbor",
        "validationRequired": "Prosím uveďte buď EUID alebo živnostenský list",
        "invalidFileType": "Sú akceptované iba PDF súbory"
      },
      "countOfSims": "Počet objednaných SIM kariet nemôže byť väčší ako trojnásobok pôvodnej objednávky",
      "simsAmount": "Počet SIM kariet",
      "differentSimsAmount": "Objednať iný počet SIM kariet",
      "acceptProposal": "Prijať ponuku"
    },
    "refuseDialog": {
      "refuseDialogTitle": "Potvrdenie odmietnutia ponuky"
    },
    "refuseForm": {
      "reasonText": "Uveďte, prosím, dôvod odmietnutia ponuky",
      "refuseDialogText": "Ste si istí, že chcete návrh odmietnuť?",
      "proposalRefuseFailed": "Zamietnutie návrhu sa nepodarilo"
    },
    "proposalLoading": "Načítanie ponúk...",
    "proposalLoadDataFailed": "Načítanie ponuky sa nepodarilo",
    "proposalIsAccepted": "Ponuka je prijatá",
    "proposalIsRefused": "Ponuka je odmietnutá.",
    "proposalExpired": "Platnosť ponuky vypršala",
    "proposalNumber": "Ponuka č.",
    "validTo": "Platnosť do",
    "vop": {
      "disclaimer": "Všetky informácie o spracúvaní osobných údajov a platné všeobecné obchodné podmienky (VOP) nájdete v",
      "link": "tomto PDF"
    }
  },
  "languages": {
    "en": "English",
    "cs": "Čeština",
    "sk": "Slovenský",
    "pl": "Polski",
    "de": "Deutsch"
  }
}
